<template>
     <v-card>
        <v-row>
         <v-col xs="12" sm="12" md="6" lg="6" xl="6">
            <v-calendar
            ref="calendar"
            v-model="start"
            :max-days="maxDays"
            :weekdays="weekdays"
            :first-interval="intervals.first"
            :interval-minutes="intervals.minutes"
            :interval-count="intervals.count"
            :interval-height="intervals.height"
            :short-intervals="shortIntervals"
            :short-months="shortMonths"
            :short-weekdays="shortWeekdays"
            :color="color"
            :locale="direction?'ar':'en'"
            :event-overlap-threshold="45"
            ></v-calendar>
         </v-col>
         <v-col xs="12" sm="12" md="6" lg="6" xl="6">
            <v-card>
               <v-card-title>
                  {{$t("INSTRUCTIONS")}}
               </v-card-title>
               <v-card-text>
                  <v-list three-line>
                     <div v-for="instruction in instructions" :key="instruction">
                        <v-list-item
                        :key="instruction.title"
                        >
                           <v-list-item-content>
                              <strong><v-list-item-title class="h4" v-html="serverTranslate(instruction.title)"></v-list-item-title></strong>
                              <div class="h5" v-html="serverTranslate(instruction.subtitle)"></div>
                           </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                     </div>
                  </v-list>
               </v-card-text>
            </v-card>
         </v-col>
       </v-row>
       <v-row>
          <v-col cols="12">
             <v-card
             tile
             >
               <v-card-title class="text-center">
                  {{$t("NOTIFICATIONS")}}
               </v-card-title>
               <div v-for="notification in notifications" :key="notification">
                  <v-list-item>
                     <v-list-item-content>
                        <v-list-item-title class="h4">({{notification.demandID}}) - {{serverTranslate(notification.scopeName)}}</v-list-item-title>
                        <v-list-item-subtitle class="text--primary">
                          {{notification.sendingDate}}
                        </v-list-item-subtitle>
                        <div v-text="notification.messageName"></div>
                     </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
               </div>
               <v-alert v-show="notifications.length == 0">
                  {{$t("NO_NOTIFICATIONS")}}
               </v-alert>
            </v-card>
          </v-col>
       </v-row>
    </v-card>
</template>
<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
export default {
   props:["notifications"],
   mixins: [serverTranslationsMixin],
   computed: {
     direction: function() {
       return this.$store.state.direction;
     }
  },
   data() {
      return {
         mode: 'stack',
         weekdays: [0, 1, 2, 3, 4, 5, 6],
         intervals: {
            first: 0,
            minutes: 60,
            count: 24,
            height: 48,
         },
         maxDays: 7,
         color: 'primary',
         shortIntervals: true,
         shortMonths: false,
         shortWeekdays: false,
         instructions:[
            {
               "title":"إرشاد 1|Instruction 1",
                "subtitle":"<p>"+
                  "في حالة مواجهة بعض المشكلات أثناء تسجيل الطلب, يرجى تحديث المتصفح لأحدث نسخة."+
                  "<br>" +
                  "لن يتم قبول تسجيلك بالجامعة إلا بعد تقديم أصول مستندات الالتحاق واعتماد قبولك من مكتب قبول الجامعات الخاصة والأهلية التابع لوزارة التعليم العالي قبل انعقاد امتحانات نهاية الفصل الدراسي."+
                  "</p>"+
                  "|"+"<p>"+"In case you encounter some problems while registering the request, please update your browser to the latest version."
                  +"<br>" +
                  "Your registration at the university will only be accepted after submitting the original enrollment documents and approval of the admission office for private and private universities affiliated to the Ministry of Higher Education before the semester-end exams are held."
            },
            {
               "title":"إرشاد 2|Instruction 2",
                "subtitle":"<p>"+
                     "يرجى التأكد من صحة البيانات الواردة بطلب الالتحاق ومطابقتها للواقع مع دعمها بالمستندات الأصلية فورا حال طلبها والا سوف تلغى استمارة التقديم تلقائيا." +
                        "<br>"+
                        "الدراسة باللغة الإنجليزية وتكون بنظام الساعات المعتمدة."+
                     "</p>"
                     +"|"+"<p>"+
                     "Please make sure that the data contained in the application for admission are correct and match the reality with supporting it with the original documents immediately if requested, otherwise the application form will be automatically canceled."
                     +"<br>"+
                     "The study is in English and is based on e-learning and credit hours."+
                     "</p>"
            }
         ]
      }
   }
};
</script>
